// @ts-expect-error migrate upstream
import { getDemo } from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate upstream
import { connect } from 'general-store';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import compose from 'transmute/compose';
import UIHeader from 'UIComponents/layout/UIHeader';
import UITag from 'UIComponents/tag/UITag';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error migrate upstream
import { DefaultDashboardDependency } from '../../../dependencies/DashboardDependency';
import AddReport from './AddReport';
import AsyncTitle from './AsyncTitle';
import { getDescription, getId, getShowDescription
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate upstream
import toClass from '../../../decorators/toClass';
import DashboardActionDropdown from './DashboardActionDropdown';
// @ts-expect-error migrate upstream
import { isUserOwner } from 'dashboard-lib/public/dashboard/dashboard-logic';
// @ts-expect-error migrate upstream
import { selectUserId } from 'dashboard-lib/public/userInfo';
// @ts-expect-error migrate upstream
import DiscoverDashboardsButton from 'reporting-action-components/reportingActions/createDashboard/DiscoverDashboardsButton';
// @ts-expect-error migrate upstream
import { UPGRADE_POINT_LOCATIONS } from 'reporting-action-components/reportingActions/shared/upgradePoints/upgradePointKeys';
// @ts-expect-error migrate upstream
import { isNil } from 'dashboard-lib/private/js-util';
import UITruncateString from 'UIComponents/text/UITruncateString';
// @ts-expect-error migrate upstream
import { DashboardUITracker } from 'dashboard-ui-components/tracking/DashboardUITracker';
import HR from 'UIComponents/elements/HR';
import DashboardDetailsButton from './DashboardDetailsButton';
import ShareActionsDropdown from './ShareActionsDropdown';
import { AsyncUsageLimitCounter as UIUsageLimitCounter } from './AsyncUsageLimitCounter';
// @ts-expect-error migrate upstream
import { DashboardCountDependency } from '../../../dependencies/DashboardsDependency';
// @ts-expect-error migrate upstream
import useDashboardLimit from 'reporting-action-components/access/limits/hooks/useDashboardLimit';
import { useIsFTS0015Variant } from '../../../hooks/useIsFTS0015Variant';
import { DashboardHeaderErrorBoundary } from './DashboardHeaderErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LIMIT_THRESHOLD = 0.5;
const indexOfNewLine = str => {
  return ['</p>', '</li>'].reduce((minIndex, ele) => {
    const eleIndex = str.indexOf(ele);
    if (eleIndex > -1) {
      const newLineIndex = eleIndex + ele.length;
      return minIndex === -1 ? newLineIndex : Math.min(minIndex, newLineIndex);
    }
    return minIndex;
  }, -1);
};
const Header = ({
  dashboard = null,
  defaultDashboardId = null,
  enterPresentationMode = () => {},
  dashboardsCount = 0,
  children
}) => {
  const dashboardId = getId(dashboard);
  const userId = useSelector(selectUserId);
  const dashboardLimit = useDashboardLimit();
  const showUsageLimitCounter = dashboardsCount / dashboardLimit > LIMIT_THRESHOLD;
  const {
    isFTS0015Variant,
    isFTS0015Fetched
  } = useIsFTS0015Variant(showUsageLimitCounter);
  if (isNil(dashboard)) {
    return null;
  }
  const isOwner = isUserOwner(userId, dashboard);
  const renderAddReport = () => /*#__PURE__*/_jsx(AddReport, {
    currentDashboardId: dashboardId,
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboardHeader.addReport.title"
    }),
    sourceName: "dashboard-header"
  });
  const renderDemoTag = () => {
    return getDemo(dashboard) ? /*#__PURE__*/_jsx(UITag, {
      inline: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboardHeader.demo"
      })
    }) : null;
  };
  const renderDefaultTag = () => {
    return defaultDashboardId && defaultDashboardId === dashboardId ? /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `setDefaultDashboard.defaultTagTooltip`
      }),
      children: /*#__PURE__*/_jsx(UITag, {
        use: "thunderdome",
        "data-test-id": "default-dashboard-tag",
        inline: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `setDefaultDashboard.defaultDashboard`
        })
      })
    }) : null;
  };
  const renderDashboardTags = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [renderDemoTag(), renderDefaultTag()]
    });
  };
  const renderShareActions = () => /*#__PURE__*/_jsx(ShareActionsDropdown, {
    currentDashboardId: dashboardId,
    dashboard: dashboard
  });
  const renderActions = () => /*#__PURE__*/_jsx(DashboardActionDropdown, {
    currentDashboardId: dashboardId,
    dashboard: dashboard,
    isOwner: isOwner,
    enterPresentationMode: enterPresentationMode
  });
  const renderAddDashboard = () => /*#__PURE__*/_jsx(DiscoverDashboardsButton, {
    appUsageTracker: DashboardUITracker,
    dashboardId: dashboardId,
    size: "sm",
    upgradeLocation: UPGRADE_POINT_LOCATIONS.DASHBOARD_CREATE,
    use: "secondary"
  });
  const renderDashboardDescription = () => {
    const description = getDescription(dashboard);
    if (!getShowDescription(dashboard) || description.length === 0) {
      return null;
    }

    //UITruncateString doesn't work as expected with the combo of html elements & multiple lines of content, so limit it to one line for the description preview in the header
    const newLineIndex = indexOfNewLine(description);
    const firstPgh = newLineIndex > -1 ? description.slice(0, newLineIndex) : description;
    const descriptionPreviewText = firstPgh.replace(/<\/?(p|ul|li)>/g, '');
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(HR, {
        className: "m-all-0"
      }), /*#__PURE__*/_jsx(UITruncateString, {
        className: "m-bottom-2 m-top-2",
        useFlex: true,
        fixedChildren: /*#__PURE__*/_jsx(Flex, {
          flexShrink: "0",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(DashboardDetailsButton, {
            dashboard: dashboard,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "dashboardHeader.seeFullDescription"
            })
          })
        }),
        tooltip: false,
        children: /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: descriptionPreviewText
          }
        })
      })]
    });
  };
  const renderUsageLimitCounter = () => {
    return /*#__PURE__*/_jsx(UIUsageLimitCounter, {
      upgradeKey: "fts-0008-suite-starter-reports-dashboard-create-dashboard",
      currentUsage: Math.min(dashboardsCount, dashboardLimit),
      usageLimit: dashboardLimit,
      usageLimitNextTier: 10
    });
  };
  const renderChildren = () => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [isFTS0015Fetched && isFTS0015Variant && renderUsageLimitCounter(), renderAddDashboard(), renderActions(), renderShareActions(), renderAddReport(), children]
    });
  };
  const title = /*#__PURE__*/_jsx(AsyncTitle, {
    dashboard: dashboard,
    defaultDashboardId: defaultDashboardId,
    currentDashboardId: dashboardId
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "HEADER_LOADED",
    children: /*#__PURE__*/_jsxs(DashboardHeaderErrorBoundary, {
      dashboardId: dashboardId,
      children: [/*#__PURE__*/_jsx(UIHeader, {
        "data-onboarding": "dashboard-header",
        flush: true,
        title: title,
        titleControls: renderDashboardTags(),
        use: "condensed",
        children: renderChildren()
      }), renderDashboardDescription()]
    })
  });
};
export default compose(connect({
  defaultDashboardId: DefaultDashboardDependency,
  dashboardsCount: DashboardCountDependency
}), toClass)(Header);